import React from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import SettingsIcon from '@mui/icons-material/Settings';
import BuildIcon from '@mui/icons-material/Build';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SchoolIcon from '@mui/icons-material/School';
import PeopleIcon from '@mui/icons-material/People';
import EventIcon from '@mui/icons-material/Event';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { Container, Header, HeaderLeft, BackButton, Title, Content, MainSection } from '../common/styles';
import { StyledCard, StyledIconButton } from '../LandingPage/styles';

const cards = [
  {
    id: 'skill-matrix-sessions',
    title: 'Skills Matrix Sessions',
    description: 'Create and manage skills matrix review sessions',
    icon: <EventIcon />,
    path: '/skills-matrix/sessions',
    customIconStyle: { 
      backgroundColor: '#8B5CF6',
    }
  },
  {
    id: 'skills-matrix-templates',
    title: 'Skills Matrix Templates',
    description: 'Create and manage skills matrix templates',
    icon: <SettingsIcon />,
    path: '/skills-matrix/templates',
    customIconStyle: { 
      backgroundColor: '#9C27B0',
    }
  },
  {
    id: 'skills',
    title: 'Skills',
    description: 'Configure and manage skills',
    icon: <BuildIcon />,
    path: '/skills-matrix/skills',
    customIconStyle: { 
      backgroundColor: '#FF5722',
    }
  },
  {
    id: 'competency-templates',
    title: 'Competency Templates',
    description: 'Create and manage competency frameworks',
    icon: <SchoolIcon />,
    path: '/skills-matrix/competency-templates',
    customIconStyle: { 
      backgroundColor: '#4CAF50',
    }
  },
  {
    id: 'employee-matrix-matching',
    title: 'Individual Matrix Matching',
    description: 'Match individuals with skills matrix',
    icon: <PeopleIcon />,
    path: '/skills-matrix/employee-matrix-matching',
    customIconStyle: { 
      backgroundColor: '#607D8B',
    }
  }
];

const SkillsMatrix = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <BackButton onClick={() => navigate('/')}>
            <FaArrowLeft /> Back to Dashboard
          </BackButton>
          <Title>Skills Matrix Configuration</Title>
        </HeaderLeft>
      </Header>

      <Content>
        <MainSection>
          <Typography variant="body1" paragraph>
            Select a configuration option to manage skills matrix settings
          </Typography>
          
          <Grid container spacing={3}>
            {cards.map((card) => (
              <Grid item xs={12} md={6} key={card.id}>
                <StyledCard onClick={() => navigate(card.path)}>
                  <StyledIconButton
                    sx={{ 
                      ...card.customIconStyle,
                      '&:hover': {
                        ...card.customIconStyle
                      }
                    }}
                  >
                    {card.icon}
                  </StyledIconButton>
                  <Typography variant="h6" align="center">{card.title}</Typography>
                  <Typography variant="body2" color="textSecondary" align="center">
                    {card.description}
                  </Typography>
                </StyledCard>
              </Grid>
            ))}
          </Grid>
        </MainSection>
      </Content>
    </Container>
  );
};

export default SkillsMatrix; 